import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { map } from 'lodash'
import { TransferData } from '../apis/transfer.api'
import Card from '../components/Card'
import PageHeading from '../components/PageHeading'
import TableHorizontal, {
  TableHorizontalData,
  TableHorizontalHeader
} from '../components/TableHorizontal'
import CardButton from '../components/CardButton'

interface InventoryHistoryTableProps {
  transfers: TransferData[]
}

export default class InventoryHistoryTable
  extends Component<InventoryHistoryTableProps> {
  tableHeaders: TableHorizontalHeader[] = [
    { heading: i18n("QR code"), path: 'pallet.code' },
    { heading: i18n("Pallet"), path: 'pallet.number' },
    { heading: i18n("Location"), path: 'locationName' },
    { heading: i18n("Created at"),
      path: 'createdAt',
      date: true,
      tooltip: ['createdUser.username']
    }
  ]

  get tableData (): any {
    return map(this.props.transfers, (transfer: TableHorizontalData<TransferData>) => {
      const { location } = transfer
      transfer.locationName = location ? location.name : transfer.type
      return transfer
    })
  }

  render () {
    return (
      <Card>
        <PageHeading
          text={i18n("Inventory History")}
          doc='inventories-view-inventorys-history' />
        <TableHorizontal
          headers={this.tableHeaders}
          data={this.tableData} />
        <CardButton cancelText={i18n("Back")} />
      </Card>
    )
  }
}
